import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  settings_type: { id: 'towingRecord.settings.type', defaultMessage: 'Type' },
  settings_station: { id: 'towingRecord.settings.station', defaultMessage: 'Station' },
  settings_operator: { id: 'towingRecord.settings.operator', defaultMessage: 'Operator' },
  settings_header: { id: 'towingRecord.settings.header', defaultMessage: 'Order settings' },
  settings_notificationMethod: { id: 'towingRecord.settings.notificationMethod', defaultMessage: 'Seurantalinkki' },
  settings_operatorPlaceholder: { id: 'towingRecord.settings.operatorPlaceholder', defaultMessage: 'Ei osoitettu' },
  settings_notificationMethodPlaceholder: {
    id: 'towingRecord.settings.notificationMethodPlaceholder',
    defaultMessage: 'Älä lähetä',
  },
})
